// extracted by mini-css-extract-plugin
export default {"container":"policy_info_section_container__Ldjh1","title":"policy_info_section_title__gwHv9"};